<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgb(0,0,0,0)" color = "#00ff00"></ngx-spinner>
    <data-table id="drivers-grid"
        headerTitle=""
        [items]="items"
        [itemCount]="itemCount"
                [autoReload]="false"
                [header]="true"
                [sortBy]="'lastName'"
                [sortAsc]="true"
                (reload)="reloadItems($event)"
        (rowClick)="rowClick($event)"

        [rowTooltip]="rowTooltip"
                [expandableRows]="false"
                [indexColumn] ="false"
                [selectColumn]="false"
                [substituteRows]="false"
        >
      <ng-template #dataTableExpand let-item="item">
        <div [textContent]="item.comments" style="padding: 5px; color: gray; font-size: 0.85em;"></div>
      </ng-template>
        <data-table-column
          [property]="'personID'"
          [header]="'personID'"
          width="100px"
         [visible]="false">
        </data-table-column>
        <data-table-column
            [property]="'firstName'"
            [header]="'First Name'"
            [sortable]="true"
            [resizable]="true"
             width="200px">
        </data-table-column>
      <data-table-column
        [property]="'lastName'"
        [header]="'Last Name'"
        [sortable]="true"
        [resizable]="true"
        width="220px">
      </data-table-column>
      <data-table-column
        [property]="'email'"
        [header]="'Email'"
        [sortable]="false"
        [resizable]="true">
      </data-table-column>
        <data-table-column
            property="phoneNumber"
            header="Phone#"
            width="150px">
        </data-table-column>
    </data-table>

